import { render } from "./PerfilView.vue?vue&type=template&id=f61a8e14"
import script from "./PerfilView.vue?vue&type=script&lang=js"
export * from "./PerfilView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__